export interface ContractItem {
  id: string;
  itemHashName: string;
  acquiredPrice: number;
  item: {
    name: string;
    imageUrl: string;
    rarityColor: string;
    rarityName: string;
    wear?: string | null;
  };
}

export interface ContractPreviewData {
  minValue: number;
  maxValue: number;
  totalInputValue: number;
}

export const CONTRACT_LIMITS = {
  MIN_ITEMS: 3,
  MAX_ITEMS: 10,
  MIN_TOTAL_VALUE: 1500,
} as const;

export type ContractValidationError = 'min_items' | 'max_items' | 'min_value';

export interface ContractValidation {
  valid: boolean;
  errorCode?: ContractValidationError;
}

export const validateContractSelection = (items: ContractItem[]): ContractValidation => {
  if (items.length < CONTRACT_LIMITS.MIN_ITEMS) {
    return { valid: false, errorCode: 'min_items' };
  }

  if (items.length > CONTRACT_LIMITS.MAX_ITEMS) {
    return { valid: false, errorCode: 'max_items' };
  }

  const totalValue = items.reduce((sum, item) => sum + item.acquiredPrice, 0);
  if (totalValue < CONTRACT_LIMITS.MIN_TOTAL_VALUE) {
    return { valid: false, errorCode: 'min_value' };
  }

  return { valid: true };
};
